module.exports = __webpack_public_path__ + "static/yen-6ecfe343909c1e56c923a1084bb10289.jpg";